const isBlank = (value: unknown) =>
  value === null || typeof value === "undefined" || value === "";

/** A count with thousands separators; blank stays blank. */
export function formatAutomationCountValue(value: unknown) {
  if (isBlank(value)) {
    return "";
  }

  const numericValue = Number(value);

  if (!Number.isFinite(numericValue)) {
    return String(value);
  }

  return numericValue.toLocaleString("en-GB", {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  });
}

/** A rate as a percentage; a fraction up to 1 is read as one. Blank stays blank. */
export function formatAutomationRateValue(value: unknown) {
  if (isBlank(value)) {
    return "";
  }

  const numericValue = Number(value);

  if (!Number.isFinite(numericValue)) {
    return String(value);
  }

  const percentageValue =
    numericValue > 0 && numericValue <= 1 ? numericValue * 100 : numericValue;
  const roundedPercentage = Number.isInteger(percentageValue)
    ? percentageValue
    : Number(percentageValue.toFixed(1));

  return `${roundedPercentage}%`;
}
